import { MemberTypeEnum, ValidatorResponse } from "src/model"
import utility from "./utility";

const inputValidator = (data: any, exemptedPropertes?: string[]): ValidatorResponse => {
    var result = <ValidatorResponse>{ isValidated: true }
    var result = <ValidatorResponse>{ isValidated: true }
    for (let key in data) {
        if (!data[key] && !exemptedPropertes?.includes(key)) {
            result.isValidated = false;
            result.message = `Input: Kindly provide 
            "${utility.splitCamelCase(key, true)}"`
            break;
        }
    }
    console.log({ result })
    return result
}

export default {
    inputValidator
}

export const getCurrentPage = () => {
    if (typeof window !== undefined) {
        return window.location.pathname.split('/').pop()
    }
}

export const getTeachersList = (data: any) => {
    return data?.basicAppInfo?.users?.filter(
        (user: any) => user.memberType === MemberTypeEnum.TEACHER
    )?.sort((a: any, b: any) => b.surname < a.surname ? 1 : -1) ?? [];
}

export const getStudentsList = (data: any) => {
    return data?.basicAppInfo?.users?.filter(
        (user: any) => user.memberType === MemberTypeEnum.STUDENT
    )?.sort((a: any, b: any) => b.surname < a.surname ? 1 : -1) ?? [];
}
export const getAllMemberInClass = (data:any,memberClass:string) => {
    let allMembers = [...getStudentsList(data), ...getTeachersList(data)] 
    return allMembers?.filter((list:any) => list?.memberClass === memberClass).map((list:any) => list?.username) ?? []
}
export const getClassList = (appInfo: any) => {
    return appInfo?.basicAppInfo?.classes?.map(
        (item: any) => item.class
    ) ?? [];
}

export const getAllStudentsInClass = (allStudents: any[], memberClass?: string) => {
    let students;
    if (memberClass) {
        students = (allStudents?.filter(
            student => student?.memberClass === memberClass
        ) ?? [])?.map( student => student?.username)
    } else {
        students = allStudents?.map( student => student?.username)
    }
    
    return students ?? [];
}

export const limitTextCharacter = (text: string, limit: number = 13) => {
    const isLess = text.length < limit;
    const limitedText = `${text.slice(0, limit)}${isLess ? "" : "..."}`;
    return limitedText;
}
export const getMemberUsernames = (members: string[]) => {
   const memberUsernames = members?.map((member:any) => member.username)
   return memberUsernames
}
export const getMember = (basicAppInfo:any, memberUsername:string) => {
    const student = basicAppInfo?.users?.find((member:any) => member.username === memberUsername )
    return student
}


export const getAcademicSessions = () => {
    let year = new Date().getFullYear()
    let academicSessions = []
    let startingYear = 2020
    while (year >= startingYear && academicSessions.length != 10) {
        let sessionString = `${year}/${year + 1}`
        academicSessions.push(sessionString)
        year--
    }
    return academicSessions
}

export const getStudentByUserName = (appInfo: any, userName: string) => {
    const studentList = getStudentsList(appInfo);
    const studentData = studentList?.find( (student: any) => student?.username === userName);
    return studentData;
}

export const getIndex = (list:any, item:any ) => {
    const index = list.indexOf(item);
    return index + 1
}
export const validateMemberType = (profile:any,userDetail?:any) => {
    if(profile.memberType === MemberTypeEnum.STUDENT) {
        return profile
    }
    else {
        return userDetail
    }

}
export const typeMember = ['Teacher', 'Student']
export const typeGender = ['Male', 'Female']